module.exports = __webpack_public_path__ + "img/FR30076.594e7b41.svg";